import {useCallback, useEffect} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {setIsCreditCardLoading} from 'desktop/pages/checkout/store/reducers/primer/primer';
import {getCompleteOrderResult} from 'desktop/pages/checkout/store/selectors/completeOrder/completeOrder';

/**
 * hook for handle loading and complete order rejection (save order fail)
 */
export const useHandleOrderCompletion = () => {
    const dispatch = useDispatch();
    const {status, success} = useSelector(getCompleteOrderResult);

    const setLoading = useCallback(
        (isLoad: boolean) => {
            dispatch(setIsCreditCardLoading(isLoad));
            window.onbeforeunload = isLoad ? () => true : null;
        },
        [dispatch],
    );

    useEffect(() => {
        // set loading false when save order failed
        if (!success && status === 'rejected') {
            setLoading(false);
        }
    }, [success, status, setLoading]);

    return {setLoading};
};
